import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useQueryGetBrokeFlexMessageCampaigns from '../../api/hooks/useQueryGetBrokeFlexMessageCampaigns'
import BrokeFlexMessageListing from '../../components/BrokeFlexMessageListing'

const ManageBrokeFlexMessagePage = () => {
	const { data: campaignsData, isLoading } =
		useQueryGetBrokeFlexMessageCampaigns()

	return (
		<PageContainer>
			<BrokeFlexMessageListing
				data={campaignsData?.data || []}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedManageBrokeFlexMessagePage = withUserPermission(
	ManageBrokeFlexMessagePage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_SMS],
	},
)

export { GuardedManageBrokeFlexMessagePage as ManageBrokeFlexMessagePage }
